import React from 'react'
import PropTypes from 'prop-types'
import { Margin, Text } from 'shared/components'
import { auth } from 'routes/route.map'
import { TransitionLink } from 'local/components'

import LoginForm from './components/loginForm'

import * as styles from './styles'

const LoginComponent = ({ onSubmit }) => (
  <Margin top={4} resetWhen="phone" css={styles.loginContainer}>
    <section css={styles.loginSection}>
      <Margin as="section" bottom={2}>
        <Text as="h2" size={24} white>
          Log In to Inwin Sport
        </Text>
      </Margin>
      <section>
        <TransitionLink
          text="Don't have an account?"
          linkText="Sign up"
          to={auth.signup()}
        />
      </section>
      <Margin as="section" tb={2}>
        <LoginForm onSubmit={onSubmit} />
      </Margin>
    </section>
  </Margin>
)

LoginComponent.propTypes = {
  onSubmit: PropTypes.func.isRequired,
}

export default LoginComponent
